
export const localPages = [
  {
    id: 'home',
    title: 'Home',
    titleAr: 'الرئيسية',
    description: 'Landing page with overview of all features and services',
    descriptionAr: 'الصفحة الرئيسية مع نظرة عامة على جميع الميزات والخدمات',
    link: '/',
    category: 'page',
    keywords: ['home', 'landing', 'main', 'start', 'homepage', 'welcome', 'الرئيسية', 'البداية']
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    titleAr: 'لوحة التحكم',
    description: 'Your personal dashboard with stats, analytics, and activity overview',
    descriptionAr: 'لوحة التحكم الشخصية مع الإحصائيات والتحليلات ونظرة عامة على النشاط',
    link: '/dashboard',
    category: 'page',
    keywords: ['dashboard', 'stats', 'overview', 'main', 'analytics', 'insights', 'لوحة التحكم', 'إحصائيات']
  },
  {
    id: 'overview',
    title: 'Overview',
    titleAr: 'نظرة عامة',
    description: 'Complete overview of your job search activities and progress',
    descriptionAr: 'نظرة عامة كاملة على أنشطة البحث عن وظيفة والتقدم',
    link: '/overview',
    category: 'page',
    keywords: ['overview', 'summary', 'activity', 'progress', 'نظرة عامة', 'ملخص']
  },
  {
    id: 'cv-builder',
    title: 'CV Builder',
    titleAr: 'منشئ السيرة الذاتية',
    description: 'Build and edit your professional resume with our intuitive CV builder',
    descriptionAr: 'أنشئ وحرر سيرتك الذاتية المهنية باستخدام منشئ السيرة الذاتية البديهي',
    link: '/cv-builder',
    category: 'page',
    keywords: ['cv', 'resume', 'builder', 'create', 'edit', 'professional', 'سيرة ذاتية', 'إنشاء']
  },
  {
    id: 'cv-generation',
    title: 'AI CV Generation',
    titleAr: 'إنشاء السيرة الذاتية بالذكاء الاصطناعي',
    description: 'Generate professional CV content using advanced AI technology',
    descriptionAr: 'أنشئ محتوى سيرة ذاتية احترافية باستخدام تقنية الذكاء الاصطناعي المتقدمة',
    link: '/cv-generation',
    category: 'page',
    keywords: ['ai', 'generate', 'cv', 'resume', 'automatic', 'smart', 'artificial intelligence', 'ذكاء اصطناعي', 'توليد']
  },
  {
    id: 'job-search',
    title: 'Job Search',
    titleAr: 'البحث عن وظائف',
    description: 'Search and find jobs that match your profile across multiple platforms',
    descriptionAr: 'ابحث وابحث عن وظائف تتناسب مع ملفك الشخصي عبر منصات متعددة',
    link: '/job-search',
    category: 'page',
    keywords: ['job', 'search', 'find', 'career', 'opportunities', 'work', 'employment', 'وظائف', 'بحث']
  },
  {
    id: 'job-library',
    title: 'Job Library',
    titleAr: 'مكتبة الوظائف',
    description: 'Browse saved jobs, applications, and manage your job search collection',
    descriptionAr: 'تصفح الوظائف المحفوظة والطلبات وإدارة مجموعة البحث عن وظائف',
    link: '/job-library',
    category: 'page',
    keywords: ['library', 'saved', 'jobs', 'collection', 'bookmarks', 'applications', 'مكتبة', 'محفوظات']
  },
  {
    id: 'job-match',
    title: 'Job Match',
    titleAr: 'مطابقة الوظائف',
    description: 'AI-powered job matching to find the best opportunities for you',
    descriptionAr: 'مطابقة وظائف مدعومة بالذكاء الاصطناعي للعثور على أفضل الفرص لك',
    link: '/job-match',
    category: 'page',
    keywords: ['match', 'ai', 'matching', 'recommendations', 'smart', 'مطابقة', 'توصيات']
  },
  {
    id: 'remote-jobs',
    title: 'Remote Jobs',
    titleAr: 'وظائف عن بعد',
    description: 'Find remote work opportunities and work from anywhere',
    descriptionAr: 'ابحث عن فرص عمل عن بعد واعمل من أي مكان',
    link: '/remote-jobs',
    category: 'page',
    keywords: ['remote', 'work from home', 'online', 'jobs', 'flexible', 'telecommute', 'عن بعد', 'من المنزل']
  },
  {
    id: 'advanced-search',
    title: 'Advanced Job Search',
    titleAr: 'البحث المتقدم عن الوظائف',
    description: 'Search jobs with advanced filters and detailed criteria',
    descriptionAr: 'ابحث عن وظائف باستخدام مرشحات متقدمة ومعايير مفصلة',
    link: '/advanced-search',
    category: 'page',
    keywords: ['advanced', 'search', 'filter', 'detailed', 'precise', 'criteria', 'متقدم', 'تصفية']
  },
  {
    id: 'cover-letter',
    title: 'Cover Letter Generator',
    titleAr: 'منشئ رسالة التغطية',
    description: 'Create professional cover letters with AI assistance',
    descriptionAr: 'أنشئ رسائل تغطية احترافية بمساعدة الذكاء الاصطناعي',
    link: '/cover-letters',
    category: 'page',
    keywords: ['cover letter', 'ai', 'generator', 'professional', 'application', 'رسالة تغطية', 'طلب']
  },
  {
    id: 'profile',
    title: 'Profile',
    titleAr: 'الملف الشخصي',
    description: 'View and edit your profile, settings, and preferences',
    descriptionAr: 'عرض وتحرير ملفك الشخصي والإعدادات والتفضيلات',
    link: '/profile',
    category: 'page',
    keywords: ['profile', 'account', 'settings', 'personal', 'info', 'preferences', 'ملف شخصي', 'حساب']
  },
  {
    id: 'settings',
    title: 'Settings',
    titleAr: 'الإعدادات',
    description: 'Manage your account settings, preferences, and subscription',
    descriptionAr: 'إدارة إعدادات حسابك والتفضيلات والاشتراك',
    link: '/settings',
    category: 'page',
    keywords: ['settings', 'preferences', 'account', 'configuration', 'subscription', 'إعدادات', 'تفضيلات']
  },
  {
    id: 'pricing',
    title: 'Pricing',
    titleAr: 'الأسعار',
    description: 'View pricing plans, subscription options, and upgrade to Pro',
    descriptionAr: 'عرض خطط التسعير وخيارات الاشتراك والترقية إلى Pro',
    link: '/pricing',
    category: 'page',
    keywords: ['pricing', 'plans', 'subscription', 'upgrade', 'pro', 'premium', 'أسعار', 'اشتراك']
  },
  {
    id: 'subscription',
    title: 'Subscription',
    titleAr: 'الاشتراك',
    description: 'Manage your subscription, billing, and payment methods',
    descriptionAr: 'إدارة اشتراكك والفواتير وطرق الدفع',
    link: '/subscription',
    category: 'page',
    keywords: ['subscription', 'billing', 'payment', 'manage', 'cancel', 'اشتراك', 'فواتير']
  },
  
  // Features
  {
    id: 'feature-ats',
    title: 'ATS-Friendly Templates',
    titleAr: 'قوالب متوافقة مع ATS',
    description: 'Templates optimized for Applicant Tracking Systems to pass automated screening',
    descriptionAr: 'قوالب محسّنة لأنظمة تتبع المتقدمين لاجتياز الفحص الآلي',
    link: '/cv-builder',
    category: 'feature',
    keywords: ['ats', 'template', 'tracking', 'system', 'optimized', 'applicant', 'قوالب', 'نظام تتبع']
  },
  {
    id: 'feature-ai-enhancement',
    title: 'AI Content Enhancement',
    titleAr: 'تحسين المحتوى بالذكاء الاصطناعي',
    description: 'Enhance your CV content with AI-powered suggestions and improvements',
    descriptionAr: 'حسّن محتوى سيرتك الذاتية باقتراحات وتحسينات مدعومة بالذكاء الاصطناعي',
    link: '/cv-generation',
    category: 'feature',
    keywords: ['ai', 'enhancement', 'improve', 'smart', 'automatic', 'optimize', 'تحسين', 'ذكي']
  },
  {
    id: 'feature-ai-generation',
    title: 'AI CV Generation',
    titleAr: 'توليد السيرة الذاتية بالذكاء الاصطناعي',
    description: 'Automatically generate professional CV sections using AI',
    descriptionAr: 'أنشئ أقسام سيرة ذاتية احترافية تلقائياً باستخدام الذكاء الاصطناعي',
    link: '/cv-generation',
    category: 'feature',
    keywords: ['ai', 'generation', 'automatic', 'create', 'professional', 'توليد تلقائي']
  },
  {
    id: 'feature-export-pdf',
    title: 'Export CV as PDF',
    titleAr: 'تصدير السيرة الذاتية كـ PDF',
    description: 'Download your CV in high-quality PDF format',
    descriptionAr: 'قم بتنزيل سيرتك الذاتية بصيغة PDF عالية الجودة',
    link: '/cv-builder',
    category: 'feature',
    keywords: ['export', 'pdf', 'download', 'save', 'print', 'تصدير', 'تنزيل']
  },
  {
    id: 'feature-export-word',
    title: 'Export CV as Word',
    titleAr: 'تصدير السيرة الذاتية كـ Word',
    description: 'Download your CV in editable Word document format',
    descriptionAr: 'قم بتنزيل سيرتك الذاتية بصيغة مستند Word قابلة للتحرير',
    link: '/cv-builder',
    category: 'feature',
    keywords: ['export', 'word', 'docx', 'download', 'editable', 'تصدير', 'وورد']
  },
  {
    id: 'feature-multilang',
    title: 'Multi-language Support',
    titleAr: 'دعم متعدد اللغات',
    description: 'Create CVs in multiple languages including English and Arabic',
    descriptionAr: 'أنشئ سيراً ذاتية بلغات متعددة بما في ذلك الإنجليزية والعربية',
    link: '/cv-builder',
    category: 'feature',
    keywords: ['language', 'multilingual', 'translation', 'arabic', 'english', 'لغات', 'ترجمة']
  },
  {
    id: 'feature-job-matching',
    title: 'AI Job Matching',
    titleAr: 'مطابقة الوظائف بالذكاء الاصطناعي',
    description: 'Get AI-powered job recommendations based on your profile',
    descriptionAr: 'احصل على توصيات وظائف مدعومة بالذكاء الاصطناعي بناءً على ملفك الشخصي',
    link: '/job-match',
    category: 'feature',
    keywords: ['matching', 'ai', 'recommendations', 'smart', 'profile', 'مطابقة', 'توصيات']
  },
  {
    id: 'feature-cover-letter',
    title: 'AI Cover Letter Generator',
    titleAr: 'منشئ رسالة التغطية بالذكاء الاصطناعي',
    description: 'Generate professional cover letters automatically with AI',
    descriptionAr: 'أنشئ رسائل تغطية احترافية تلقائياً بالذكاء الاصطناعي',
    link: '/cover-letter',
    category: 'feature',
    keywords: ['cover letter', 'ai', 'generator', 'automatic', 'professional', 'رسالة تغطية']
  },
  {
    id: 'feature-templates',
    title: 'Professional CV Templates',
    titleAr: 'قوالب سيرة ذاتية احترافية',
    description: 'Choose from multiple professional CV templates',
    descriptionAr: 'اختر من بين قوالب سيرة ذاتية احترافية متعددة',
    link: '/cv-builder',
    category: 'feature',
    keywords: ['templates', 'design', 'professional', 'modern', 'layouts', 'قوالب', 'تصاميم']
  },
  {
    id: 'feature-job-save',
    title: 'Save Jobs',
    titleAr: 'حفظ الوظائف',
    description: 'Save interesting jobs to your library for later review',
    descriptionAr: 'احفظ الوظائف المثيرة للاهتمام في مكتبتك للمراجعة لاحقاً',
    link: '/job-library',
    category: 'feature',
    keywords: ['save', 'bookmark', 'library', 'collection', 'organize', 'حفظ', 'مكتبة']
  },
  {
    id: 'feature-job-tracking',
    title: 'Application Tracking',
    titleAr: 'تتبع الطلبات',
    description: 'Track your job applications and their status',
    descriptionAr: 'تتبع طلبات وظائفك وحالتها',
    link: '/job-library',
    category: 'feature',
    keywords: ['tracking', 'applications', 'status', 'manage', 'organize', 'تتبع', 'طلبات']
  },
  {
    id: 'feature-remote-filter',
    title: 'Remote Job Filter',
    titleAr: 'تصفية الوظائف عن بعد',
    description: 'Filter and find remote work opportunities',
    descriptionAr: 'صفّ وابحث عن فرص عمل عن بعد',
    link: '/remote-jobs',
    category: 'feature',
    keywords: ['remote', 'filter', 'work from home', 'telecommute', 'عن بعد', 'تصفية']
  },
  {
    id: 'feature-advanced-filters',
    title: 'Advanced Search Filters',
    titleAr: 'مرشحات البحث المتقدمة',
    description: 'Use advanced filters to find exactly what you need',
    descriptionAr: 'استخدم مرشحات متقدمة للعثور على ما تحتاجه بالضبط',
    link: '/advanced-search',
    category: 'feature',
    keywords: ['filters', 'advanced', 'search', 'criteria', 'precise', 'مرشحات', 'بحث متقدم']
  },
  {
    id: 'feature-analytics',
    title: 'Job Search Analytics',
    titleAr: 'تحليلات البحث عن وظائف',
    description: 'Track your job search progress with analytics',
    descriptionAr: 'تتبع تقدم البحث عن وظائف باستخدام التحليلات',
    link: '/dashboard',
    category: 'feature',
    keywords: ['analytics', 'statistics', 'insights', 'tracking', 'progress', 'تحليلات', 'إحصائيات']
  }
];

/**
 * API Data Structure (example)
 * In real usage, fetch this from an API endpoint once on page load
 */
export const apiDataExample = [
  // Articles & Blog Posts
  {
    id: 'article-1',
    title: 'How to Write a Professional CV in 2025',
    titleAr: 'كيفية كتابة سيرة ذاتية احترافية في 2025',
    description: 'Complete guide to creating an impressive resume that gets you hired',
    descriptionAr: 'دليل كامل لإنشاء سيرة ذاتية مثيرة للإعجاب تساعدك في الحصول على وظيفة',
    link: '/blog/professional-cv-guide',
    category: 'article',
    keywords: ['guide', 'tutorial', 'cv', 'resume', 'professional', 'tips', 'writing', 'دليل', 'نصائح']
  },
  {
    id: 'article-2',
    title: 'Top Remote Jobs in 2025',
    titleAr: 'أفضل الوظائف عن بعد في 2025',
    description: 'Best remote work opportunities this year across various industries',
    descriptionAr: 'أفضل فرص العمل عن بعد هذا العام عبر مختلف الصناعات',
    link: '/blog/remote-jobs-2025',
    category: 'article',
    keywords: ['remote', 'jobs', '2025', 'work from home', 'opportunities', 'trending', 'عن بعد', 'وظائف']
  },
  {
    id: 'article-3',
    title: 'AI in Job Hunting: The Future is Here',
    titleAr: 'الذكاء الاصطناعي في البحث عن وظائف: المستقبل هنا',
    description: 'How AI is transforming the job search process and helping candidates',
    descriptionAr: 'كيف يحول الذكاء الاصطناعي عملية البحث عن وظائف ويساعد المرشحين',
    link: '/blog/ai-job-hunting',
    category: 'article',
    keywords: ['ai', 'job search', 'technology', 'future', 'automation', 'machine learning', 'ذكاء اصطناعي', 'مستقبل']
  },
  {
    id: 'article-4',
    title: 'ATS-Friendly Resume Tips',
    titleAr: 'نصائح للسيرة الذاتية المتوافقة مع ATS',
    description: 'How to optimize your resume for Applicant Tracking Systems',
    descriptionAr: 'كيفية تحسين سيرتك الذاتية لأنظمة تتبع المتقدمين',
    link: '/blog/ats-resume-tips',
    category: 'article',
    keywords: ['ats', 'resume', 'optimization', 'tips', 'tracking system', 'applicant', 'نصائح', 'تحسين']
  },
  {
    id: 'article-5',
    title: 'Cover Letter Writing Guide',
    titleAr: 'دليل كتابة رسالة التغطية',
    description: 'Expert tips for writing compelling cover letters that stand out',
    descriptionAr: 'نصائح الخبراء لكتابة رسائل تغطية مقنعة تتميز',
    link: '/blog/cover-letter-guide',
    category: 'article',
    keywords: ['cover letter', 'writing', 'tips', 'guide', 'professional', 'application', 'رسالة تغطية', 'كتابة']
  },
  {
    id: 'article-6',
    title: 'Job Interview Preparation Checklist',
    titleAr: 'قائمة التحقق لإعداد المقابلة الوظيفية',
    description: 'Everything you need to prepare for a successful job interview',
    descriptionAr: 'كل ما تحتاجه للتحضير لمقابلة عمل ناجحة',
    link: '/blog/interview-preparation',
    category: 'article',
    keywords: ['interview', 'preparation', 'tips', 'checklist', 'job', 'success', 'مقابلة', 'تحضير']
  },
  {
    id: 'article-7',
    title: 'Salary Negotiation Strategies',
    titleAr: 'استراتيجيات التفاوض على الراتب',
    description: 'How to negotiate your salary and get what you deserve',
    descriptionAr: 'كيفية التفاوض على راتبك والحصول على ما تستحقه',
    link: '/blog/salary-negotiation',
    category: 'article',
    keywords: ['salary', 'negotiation', 'compensation', 'strategies', 'tips', 'راتب', 'تفاوض']
  },
  {
    id: 'article-8',
    title: 'Building Your Personal Brand',
    titleAr: 'بناء علامتك التجارية الشخصية',
    description: 'How to build and maintain a strong professional personal brand',
    descriptionAr: 'كيفية بناء والحفاظ على علامة تجارية شخصية مهنية قوية',
    link: '/blog/personal-branding',
    category: 'article',
    keywords: ['personal brand', 'professional', 'networking', 'career', 'identity', 'علامة تجارية', 'احتراف']
  },
  {
    id: 'article-9',
    title: 'Career Change Guide',
    titleAr: 'دليل تغيير المسار المهني',
    description: 'Step-by-step guide to successfully changing your career path',
    descriptionAr: 'دليل خطوة بخطوة لتغيير مسارك المهني بنجاح',
    link: '/blog/career-change',
    category: 'article',
    keywords: ['career change', 'transition', 'guide', 'tips', 'new career', 'تغيير مهني', 'دليل']
  },
  {
    id: 'article-10',
    title: 'LinkedIn Profile Optimization',
    titleAr: 'تحسين ملف LinkedIn',
    description: 'Optimize your LinkedIn profile to attract recruiters',
    descriptionAr: 'حسّن ملفك الشخصي على LinkedIn لجذب القائمين بالتوظيف',
    link: '/blog/linkedin-optimization',
    category: 'article',
    keywords: ['linkedin', 'profile', 'optimization', 'networking', 'professional', 'تحسين', 'شبكات']
  },
  
  // Help & Support
  {
    id: 'help-cv',
    title: 'CV Builder Help',
    titleAr: 'مساعدة منشئ السيرة الذاتية',
    description: 'Learn how to use the CV builder tool effectively',
    descriptionAr: 'تعلم كيفية استخدام أداة منشئ السيرة الذاتية بفعالية',
    link: '/help/cv-builder',
    category: 'help',
    keywords: ['help', 'tutorial', 'cv builder', 'guide', 'how to', 'instructions', 'مساعدة', 'دليل']
  },
  {
    id: 'help-search',
    title: 'Job Search Tips',
    titleAr: 'نصائح البحث عن وظائف',
    description: 'Tips and tricks for effective job searching',
    descriptionAr: 'نصائح وحيل للبحث الفعال عن وظائف',
    link: '/help/job-search',
    category: 'help',
    keywords: ['help', 'tips', 'job search', 'guide', 'advice', 'effective', 'نصائح', 'بحث']
  },
  {
    id: 'help-ai',
    title: 'Using AI Features',
    titleAr: 'استخدام ميزات الذكاء الاصطناعي',
    description: 'Guide to using AI-powered features for CV enhancement',
    descriptionAr: 'دليل لاستخدام ميزات الذكاء الاصطناعي لتحسين السيرة الذاتية',
    link: '/help/ai-features',
    category: 'help',
    keywords: ['help', 'ai', 'features', 'guide', 'enhancement', 'tutorial', 'ذكاء اصطناعي', 'ميزات']
  },
  {
    id: 'help-export',
    title: 'Exporting Your CV',
    titleAr: 'تصدير سيرتك الذاتية',
    description: 'How to export your CV in different formats',
    descriptionAr: 'كيفية تصدير سيرتك الذاتية بتنسيقات مختلفة',
    link: '/help/export',
    category: 'help',
    keywords: ['help', 'export', 'pdf', 'word', 'download', 'formats', 'تصدير', 'تنزيل']
  },
  {
    id: 'help-templates',
    title: 'Choosing the Right Template',
    titleAr: 'اختيار القالب المناسب',
    description: 'Guide to selecting the best CV template for your needs',
    descriptionAr: 'دليل لاختيار أفضل قالب سيرة ذاتية لاحتياجاتك',
    link: '/help/templates',
    category: 'help',
    keywords: ['help', 'templates', 'guide', 'selection', 'design', 'قوالب', 'اختيار']
  },
  {
    id: 'help-cover-letter',
    title: 'Cover Letter Generator Help',
    titleAr: 'مساعدة منشئ رسالة التغطية',
    description: 'How to create effective cover letters using our tool',
    descriptionAr: 'كيفية إنشاء رسائل تغطية فعالة باستخدام أداتنا',
    link: '/help/cover-letter',
    category: 'help',
    keywords: ['help', 'cover letter', 'generator', 'guide', 'tutorial', 'رسالة تغطية', 'مساعدة']
  },
  {
    id: 'help-job-match',
    title: 'Job Matching Help',
    titleAr: 'مساعدة مطابقة الوظائف',
    description: 'Understanding how AI job matching works',
    descriptionAr: 'فهم كيفية عمل مطابقة الوظائف بالذكاء الاصطناعي',
    link: '/help/job-match',
    category: 'help',
    keywords: ['help', 'job matching', 'ai', 'guide', 'recommendations', 'مطابقة', 'توصيات']
  },
  {
    id: 'help-account',
    title: 'Account Management',
    titleAr: 'إدارة الحساب',
    description: 'Managing your account, settings, and subscription',
    descriptionAr: 'إدارة حسابك وإعداداتك واشتراكك',
    link: '/help/account',
    category: 'help',
    keywords: ['help', 'account', 'settings', 'subscription', 'manage', 'حساب', 'إدارة']
  },
  
  // FAQs
  {
    id: 'faq-general',
    title: 'General FAQs',
    titleAr: 'الأسئلة الشائعة العامة',
    description: 'Frequently asked questions about CVLogs',
    descriptionAr: 'الأسئلة المتداولة حول CVLogs',
    link: '/faq',
    category: 'faq',
    keywords: ['faq', 'questions', 'help', 'support', 'answers', 'أسئلة شائعة', 'مساعدة']
  },
  {
    id: 'faq-pricing',
    title: 'Pricing & Billing FAQs',
    titleAr: 'الأسئلة الشائعة حول التسعير والفواتير',
    description: 'Questions about pricing plans and billing',
    descriptionAr: 'أسئلة حول خطط التسعير والفواتير',
    link: '/faq#pricing',
    category: 'faq',
    keywords: ['faq', 'pricing', 'billing', 'subscription', 'payment', 'أسعار', 'فواتير']
  }
];

/**
 * Fetch API data (simulated)
 * Replace this with your actual API call
 */
export const fetchSearchData = async () => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 100));
  
  // In production, replace with:
  // const response = await fetch('/api/search-data');
  // return await response.json();
  
  return apiDataExample;
};
